export default class BuildContext {
    constructor(context) {
        const { locale = 'en_US' } = context

        this.locale = locale
    }

    getLocale() {
        return this.locale
    }
}